export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6039.84328519.jpg";